// "Message us about this account" (BRK-S159, PMS-S356): the bounds PMS's schema
// puts on a message, and the Topic the Surety profile's dialog adds (BRK-S398).
//
// The topic travels as its OWN typed field (BRK-S431), `topic` on the message
// POST — PMS-S842 (P7) — so a Signal reader can route on it
// rather than parse it out of a subject line. With a topic the subject is
// optional and goes out as typed.

export const MESSAGE_SUBJECT_MAX = 200;
export const MESSAGE_BODY_MAX = 5000;

/** What an account message is about. CLOSED, in the wireframe's order; the
 *  first is the default. PMS-S842 (P7) — `topic`. */
export const ACCOUNT_MESSAGE_TOPICS = [
  "general_question",
  "surety_program",
  "submission_or_bond",
  "account_details",
] as const;
export type AccountMessageTopic = (typeof ACCOUNT_MESSAGE_TOPICS)[number];

const TOPIC_LABELS: Record<AccountMessageTopic, string> = {
  general_question: "General question",
  surety_program: "Surety program",
  submission_or_bond: "A submission or bond",
  account_details: "Account details",
};

export function isAccountMessageTopic(v: unknown): v is AccountMessageTopic {
  return ACCOUNT_MESSAGE_TOPICS.some((t) => t === v);
}

/** A topic in words; one this build has not adopted reads "Other". */
export function accountMessageTopicLabel(raw: unknown): string {
  return isAccountMessageTopic(raw) ? TOPIC_LABELS[raw] : "Other";
}
